function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

export function CodeJar(editor, highlight) {
  var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = Object.assign({
    tab: '\t',
    indentOn: /{$/,
    spellcheck: false,
    catchTab: true,
    preserveIdent: true,
    addClosing: true,
    history: true
  }, opt);
  var listeners = [];
  var history = [];
  var at = -1;
  var focus = false;
  var callback;
  var prev; // code content prior keydown event

  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  editor.setAttribute('contentEditable', isFirefox ? 'true' : 'plaintext-only');
  editor.setAttribute('spellcheck', options.spellcheck ? 'true' : 'false');
  editor.style.outline = 'none';
  editor.style.overflowWrap = 'break-word';
  editor.style.overflowY = 'auto';
  editor.style.resize = 'vertical';
  editor.style.whiteSpace = 'pre-wrap';
  highlight(editor);
  var debounceHighlight = debounce(function () {
    var pos = save();
    highlight(editor, pos);
    restore(pos);
  }, 30);
  var recording = false;

  var shouldRecord = function shouldRecord(event) {
    return !isUndo(event) && !isRedo(event) && event.key !== 'Meta' && event.key !== 'Control' && event.key !== 'Alt' && !event.key.startsWith('Arrow');
  };

  var debounceRecordHistory = debounce(function (event) {
    if (shouldRecord(event)) {
      recordHistory();
      recording = false;
    }
  }, 300);

  var on = function on(type, fn) {
    listeners.push([type, fn]);
    editor.addEventListener(type, fn);
  };

  on('keydown', function (event) {
    if (event.defaultPrevented) return;
    prev = toString();
    if (options.preserveIdent) handleNewLine(event);else firefoxNewLineFix(event);
    if (options.catchTab) handleTabCharacters(event);
    if (options.addClosing) handleSelfClosingCharacters(event);

    if (options.history) {
      handleUndoRedo(event);

      if (shouldRecord(event) && !recording) {
        recordHistory();
        recording = true;
      }
    }
  });
  on('keyup', function (event) {
    if (event.defaultPrevented) return;
    if (event.isComposing) return;
    if (prev !== toString()) debounceHighlight();
    debounceRecordHistory(event);
    if (callback) callback(toString());
  });
  on('focus', function (_event) {
    focus = true;
  });
  on('blur', function (_event) {
    focus = false;
  });
  on('paste', function (event) {
    recordHistory();
    handlePaste(event);
    recordHistory();
    if (callback) callback(toString());
  });

  function save() {
    var s = window.getSelection();
    var pos = {
      start: 0,
      end: 0,
      dir: undefined
    };
    visit(editor, function (el) {
      if (el === s.anchorNode && el === s.focusNode) {
        pos.start += s.anchorOffset;
        pos.end += s.focusOffset;
        pos.dir = s.anchorOffset <= s.focusOffset ? '->' : '<-';
        return 'stop';
      }

      if (el === s.anchorNode) {
        pos.start += s.anchorOffset;

        if (!pos.dir) {
          pos.dir = '->';
        } else {
          return 'stop';
        }
      } else if (el === s.focusNode) {
        pos.end += s.focusOffset;

        if (!pos.dir) {
          pos.dir = '<-';
        } else {
          return 'stop';
        }
      }

      if (el.nodeType === Node.TEXT_NODE) {
        if (pos.dir != '->') pos.start += el.nodeValue.length;
        if (pos.dir != '<-') pos.end += el.nodeValue.length;
      }
    });
    return pos;
  }

  function restore(pos) {
    var s = window.getSelection();
    var startNode,
        startOffset = 0;
    var endNode,
        endOffset = 0;
    if (!pos.dir) pos.dir = '->';
    if (pos.start < 0) pos.start = 0;
    if (pos.end < 0) pos.end = 0; // Flip start and end if the direction reversed

    if (pos.dir == '<-') {
      var start = pos.start,
          end = pos.end;
      pos.start = end;
      pos.end = start;
    }

    var current = 0;
    visit(editor, function (el) {
      if (el.nodeType !== Node.TEXT_NODE) return;
      var len = (el.nodeValue || '').length;

      if (current + len >= pos.start) {
        if (!startNode) {
          startNode = el;
          startOffset = pos.start - current;
        }

        if (current + len >= pos.end) {
          endNode = el;
          endOffset = pos.end - current;
          return 'stop';
        }
      }

      current += len;
    }); // If everything deleted place cursor at editor

    if (!startNode) startNode = editor;
    if (!endNode) endNode = editor; // Flip back the selection

    if (pos.dir == '<-') {
      var _ref = [endNode, endOffset, startNode, startOffset];
      startNode = _ref[0];
      startOffset = _ref[1];
      endNode = _ref[2];
      endOffset = _ref[3];
    }

    s.setBaseAndExtent(startNode, startOffset, endNode, endOffset);
  }

  function beforeCursor() {
    var s = window.getSelection();
    var r0 = s.getRangeAt(0);
    var r = document.createRange();
    r.selectNodeContents(editor);
    r.setEnd(r0.startContainer, r0.startOffset);
    return r.toString();
  }

  function afterCursor() {
    var s = window.getSelection();
    var r0 = s.getRangeAt(0);
    var r = document.createRange();
    r.selectNodeContents(editor);
    r.setStart(r0.endContainer, r0.endOffset);
    return r.toString();
  }

  function handleNewLine(event) {
    if (event.key === 'Enter') {
      var before = beforeCursor();
      var after = afterCursor();

      var _findPadding = findPadding(before),
          _findPadding2 = _slicedToArray(_findPadding, 1),
          padding = _findPadding2[0];

      var newLinePadding = padding; // If last symbol is "{" ident new line
      // Allow user defines indent rule

      if (options.indentOn.test(before)) {
        newLinePadding += options.tab;
      } // Preserve padding


      if (newLinePadding.length > 0) {
        preventDefault(event);
        event.stopPropagation();
        insert('\n' + newLinePadding);
      } else {
        firefoxNewLineFix(event);
      } // Place adjacent "}" on next line


      if (newLinePadding !== padding && after[0] === '}') {
        var pos = save();
        insert('\n' + padding);
        restore(pos);
      }
    }
  }

  function firefoxNewLineFix(event) {
    // Firefox does not support plaintext-only mode
    // and puts <div><br></div> on Enter. Let's help.
    if (isFirefox && event.key === 'Enter') {
      preventDefault(event);
      event.stopPropagation();

      if (afterCursor() == '') {
        insert('\n ');
        var pos = save();
        pos.start = --pos.end;
        restore(pos);
      } else {
        insert('\n');
      }
    }
  }

  function handleSelfClosingCharacters(event) {
    var open = "([{'\"";
    var close = ")]}'\"";
    var codeAfter = afterCursor();
    var codeBefore = beforeCursor();
    var escapeCharacter = codeBefore.substr(codeBefore.length - 1) === '\\';
    var charAfter = codeAfter.substr(0, 1);

    if (close.includes(event.key) && !escapeCharacter && charAfter === event.key) {
      // We already have closing char next to cursor.
      // Move one char to right.
      var pos = save();
      preventDefault(event);
      pos.start = ++pos.end;
      restore(pos);
    } else if (open.includes(event.key) && !escapeCharacter // Only if string or have empty space after
    && ("\"'".includes(event.key) || ['', ' ', '\n'].includes(charAfter))) {
      // Place closing char.
      var _pos = save();

      preventDefault(event);
      var text = event.key + close[open.indexOf(event.key)];
      insert(text);
      _pos.start = ++_pos.end;
      restore(_pos);
    }
  }

  function handleTabCharacters(event) {
    if (event.key === 'Tab') {
      preventDefault(event);

      if (event.shiftKey) {
        var before = beforeCursor();

        var _findPadding3 = findPadding(before),
            _findPadding4 = _slicedToArray(_findPadding3, 2),
            padding = _findPadding4[0],
            start = _findPadding4[1];

        if (padding.length > 0) {
          var pos = save(); // Remove full length tab or just remaining padding

          var len = Math.min(options.tab.length, padding.length);
          restore({
            start: start,
            end: start + len
          });
          document.execCommand('delete');
          pos.start -= len;
          pos.end -= len;
          restore(pos);
        }
      } else {
        insert(options.tab);
      }
    }
  }

  function handleUndoRedo(event) {
    if (isUndo(event)) {
      preventDefault(event);
      at--;
      var record = history[at];

      if (record) {
        editor.innerHTML = record.html;
        restore(record.pos);
      }

      if (at < 0) at = 0;
    }

    if (isRedo(event)) {
      preventDefault(event);
      at++;
      var _record = history[at];

      if (_record) {
        editor.innerHTML = _record.html;
        restore(_record.pos);
      }

      if (at >= history.length) at--;
    }
  }

  function recordHistory() {
    if (!focus) return;
    var html = editor.innerHTML;
    var pos = save();
    var lastRecord = history[at];

    if (lastRecord) {
      if (lastRecord.html === html && lastRecord.pos.start === pos.start && lastRecord.pos.end === pos.end) return;
    }

    at++;
    history[at] = {
      html: html,
      pos: pos
    };
    history.splice(at + 1);
    var maxHistory = 300;

    if (at > maxHistory) {
      at = maxHistory;
      history.splice(0, 1);
    }
  }

  function handlePaste(event) {
    preventDefault(event);
    var text = (event.originalEvent || event).clipboardData.getData('text/plain');
    var pos = save();
    insert(text);
    highlight(editor);
    restore({
      start: pos.start + text.length,
      end: pos.start + text.length
    });
  }

  function visit(editor, visitor) {
    var queue = [];
    if (editor.firstChild) queue.push(editor.firstChild);
    var el = queue.pop();

    while (el) {
      if (visitor(el) === 'stop') break;
      if (el.nextSibling) queue.push(el.nextSibling);
      if (el.firstChild) queue.push(el.firstChild);
      el = queue.pop();
    }
  }

  function isCtrl(event) {
    return event.metaKey || event.ctrlKey;
  }

  function isUndo(event) {
    return isCtrl(event) && !event.shiftKey && event.key === 'z';
  }

  function isRedo(event) {
    return isCtrl(event) && event.shiftKey && event.key === 'z';
  }

  function insert(text) {
    text = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    document.execCommand('insertHTML', false, text);
  }

  function debounce(cb, wait) {
    var timeout = 0;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = window.setTimeout(function () {
        return cb.apply(void 0, args);
      }, wait);
    };
  }

  function findPadding(text) {
    // Find beginning of previous line.
    var i = text.length - 1;

    while (i >= 0 && text[i] !== '\n') {
      i--;
    }

    i++; // Find padding of the line.

    var j = i;

    while (j < text.length && /[ \t]/.test(text[j])) {
      j++;
    }

    return [text.substring(i, j) || '', i, j];
  }

  function toString() {
    return editor.textContent || '';
  }

  function preventDefault(event) {
    event.preventDefault();
  }

  return {
    updateOptions: function updateOptions(options) {
      options = Object.assign(Object.assign({}, options), options);
    },
    updateCode: function updateCode(code) {
      editor.textContent = code;
      highlight(editor);
    },
    onUpdate: function onUpdate(cb) {
      callback = cb;
    },
    toString: toString,
    save: save,
    restore: restore,
    recordHistory: recordHistory,
    destroy: function destroy() {
      var _iterator = _createForOfIteratorHelper(listeners),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref4 = _step.value;

          var _ref3 = _slicedToArray(_ref4, 2);

          var type = _ref3[0];
          var fn = _ref3[1];
          editor.removeEventListener(type, fn);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  };
}